import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ReportComplianceComponent from './view/report-compliance-view';

const ReportCompliance = () => {
    return (
        <ErrorBoundaryRoutes>
            <Route index element={<ReportComplianceComponent />} />
        </ErrorBoundaryRoutes>
    )
}

export default ReportCompliance;
